import { useContext, Fragment } from "react";

import MixingContext from "../../context/materialcapture/MixingContext";

import Grid from "@mui/material/Grid";
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import Stack from '@mui/material/Stack';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';

const MixingForm = () => {
  const { 
    formulationsObj, setFormulationsObj, formulationsArray, initialValues, 
    handleTypeChange, handleSubmit, formErrors, robot, setRobot, status
  } = useContext(MixingContext);

  return(
    <>
      <Grid container spacing={1} mt={1}>
        <Grid item xs={12}>
          <Typography 
            variant="h6" 
            component="h6"
            color={'text.secondary'}
            sx={{ fontWeight: 'bold', whiteSpace: 'nowrap' }}
          >
            Formulations
          </Typography>
          
          <Stack direction='row' sx={{ justifyContent: 'space-between', mr: 10, ml: 10 }}>
            <Box m={1}>
              <FormControl>
                <RadioGroup
                  row
                  aria-labelledby="formulationsLabel"
                  name="formulations"
                  value={formulationsObj?.type}
                  onChange={handleTypeChange}
                >
                  <FormControlLabel value="Plate" control={<Radio />} label="Plate" />
                  <FormControlLabel value="LNP Sample" control={<Radio />} label="LNP Sample" />
                </RadioGroup>
              </FormControl>
            </Box>
            
            <Box sx={{ width: 700 }}>
              <Autocomplete
                multiple
                id="formulationDrpDwn"
                options={formulationsArray}
                getOptionLabel={(option) => option?.name}
                value={formulationsObj?.ids}
                onChange={(event, newValue) => {
                  setFormulationsObj(prev => ({...prev, ids: newValue}));
                }}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                renderInput={(params) => (
                  <TextField 
                    {...params} 
                    label={formulationsObj?.type} 
                    placeholder="Formulation"
                    helperText={formErrors['formulation']}
                    error={'formulation' in formErrors}
                  />
                )}
                fullWidth
              />
            </Box>

            <Box>
              <FormControl sx={{ width: 200 }}>
                <InputLabel id="robotLabel">Robot</InputLabel>
                <Select
                  labelId="robotLabel"
                  id="robot"
                  value={robot}
                  label="Robot"
                  onChange={e => setRobot(e.target.value)}
                >
                  {
                    initialValues?.robotArray.map((robot, index) => (
                      <MenuItem key={index} value={robot}>{robot}</MenuItem>
                    ))
                  }
                </Select>
              </FormControl>
            </Box>

            <Box m={1}>
              <Button 
                variant='contained' 
                color='info' 
                onClick={handleSubmit}
              >
                Apply
              </Button>
            </Box>
          </Stack>
        </Grid>
      </Grid>

      <Box mt={5} sx={{ textAlign: "center"}}>
        <Typography
          variant="h6"
          component="h6"
          color={status?.success ? 'success.main' : 'error.main'}
        >
          {status?.msg}
        </Typography>
      </Box>
    </>
  );
};

export default MixingForm